import bookmarksConstants    from './bookmarks.constants';
import bookmarksInitialState from './bookmarks.state';

function bookmarksReducer(state = bookmarksInitialState, action) {
  switch (action.type) {
    case bookmarksConstants.SHOW_MODAL:
      state = {
        open: true,
      };
      break;

    case bookmarksConstants.HIDE_MODAL:
      state = { ...bookmarksInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default bookmarksReducer;
